import React, { useState } from "react";
import ReactModal from "react-modal";
import { getAllDataFromStorage, removeDataFromLocalStorage } from "../../utilities/localStorageUtils";
import { RemoveErrorButton } from "../styledComponents/Buttons.styles";


const customStyles = {
  content: {
    top: "35%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    backgroundColor: "rgba(211, 211, 211, 0.5)",
    marginRight: "-50%",
    width: "60%",
    transform: "translate(-40%, -10%)",
  },
};

const ErrorScreen = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [isReportErrorOpen, setIsReportErrorOpen] = useState(false);

  const handleSaveData = () => {
    const dataFromStorage = getAllDataFromStorage();

    const jsonData = JSON.stringify(dataFromStorage);
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${dataFromStorage.name}SRP_${dataFromStorage.version}.json`;
    link.click();

    setModalIsOpen(false);
    handleReloadPage();
    removeDataFromLocalStorage();
  };

  const handleReloadPage = () => {
    window.location.reload();
  };

  const handleReportError = () => {
    setIsReportErrorOpen(true);
  };

  return (
    <div>
      <ReactModal isOpen={modalIsOpen} >
        <h2>Something went wrong</h2>
        <p>Do you want to save your data?</p>
        <button onClick={handleSaveData} style={{margin: '10px'}}>Save Data</button>
        <button onClick={handleReportError}>Report Error</button>

        <ReactModal isOpen={isReportErrorOpen} style={customStyles}>
          <RemoveErrorButton onClick={() => setIsReportErrorOpen(false)}>
            X
          </RemoveErrorButton>

          <h2>Report Error</h2>
          <p>
            Please report the error to the development team. You can contact
            them at "CMEYER75@ford.com"
          </p>
        </ReactModal>
      </ReactModal>
    </div>
  );
};

export default ErrorScreen;
